<template>
  <div>
    <span class="bulk-editor-tool__title">Bulk Editor Tool</span>
    <div class="tools_events_bar mb-3 p-2 p-sm-3 bg-lighter border-top d-flex align-items-center flex-wrap justify-content-around">
      <f-checkbox
        id="bulk-select-all"
        label="Select all"
        :value="totalCount > 0 && selectedCount === totalCount"
        :font-normal="true"
        class="mb-0 mr-3 flex-shrink-0"
        @input="$emit('toggle-all')"
      />
      <slot />
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import FCheckbox from '@/components/FormFields/FCheckbox'

export default defineComponent({
  name: 'BulkEditorTool',
  components: { FCheckbox },
  props: {
    totalCount: { type: Number, default: 0 },
    selectedCount: { type: Number, default: 0 }
  },
  emits: ['toggle-all']
})
</script>

<style scoped>
.bulk-editor-tool__title {
  display: block;
  margin-bottom: 0.3rem;
  font-weight: 700;
  font-size: 1.094rem;
}

@media (max-width: 1024px) {
  .tools_events_bar {
    flex-direction: column !important;
    align-items: flex-start !important;
    justify-content: flex-start !important;
  }

  .tools_events_bar > * {
    margin-bottom: 0.75rem;
  }

  .tools_events_bar > *:first-child {
    margin-bottom: 0.75rem !important;
  }

  .tools_events_bar > *:last-child {
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BulkEditorTool.vue